var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../framework/Timeouts';
export class JustAddPower {
    constructor(socket, log) {
        this.socket = socket;
        this.log = log;
        this.apiState = 'username';
        this.transmitters = [];
        this.vlans = [];
        this.timeouts = new Timeouts();
        this.useBig = false;
        this.apiAsyncHandlers = [
            {
                regExp: /^con t/i,
                callback: (match) => {
                    this.socket.send(match[0]);
                    this.socket.sendRaw(`(config)# `);
                },
            },
            {
                regExp: /^end$/i,
                callback: (match) => {
                    this.socket.send(match[0]);
                },
            },
            {
                regExp: /^int gi (\d+)\/(\d+)$/i,
                callback: (match) => {
                    this.socket.send(match[0]);
                    this.rxInterface = {
                        unit: parseInt(match[1], 10),
                        port: parseInt(match[2], 10),
                    };
                    this.socket.sendRaw(`(config-if)# `);
                },
            },
            {
                regExp: /^show int gi (\d+)\/(\d+) sw/i,
                callback: (match) => {
                    const unit = parseInt(match[1], 10);
                    const port = parseInt(match[2], 10);
                    const vlansEnabled = this.vlans
                        .filter(vlan => vlan.interfaces.find(iface => iface.unit === unit && iface.port === port) !== undefined)
                        .map(vlan => vlan.number)
                        .sort()
                        .join(',');
                    const transmitter = this.transmitters.find(tx => tx.unit === unit && tx.port === port);
                    let nativeVlan = 10;
                    if (transmitter !== undefined) {
                        const txVlan = this.vlans.find(vlan => vlan.number > 10 &&
                            vlan.interfaces.find(iface => iface.unit === transmitter.unit &&
                                iface.port === transmitter.port) !== undefined);
                        if (txVlan === undefined) {
                            this.log.error(`transmitter not found in vlan`);
                        }
                        else {
                            nativeVlan = txVlan.number;
                        }
                    }
                    this.socket.send(match[0]);
                    this.socket.send(`Name: GigabitEthernet ${unit}/${port}`);
                    this.socket.send(`Administrative mode: hybrid`);
                    this.socket.send(`Access Mode VLAN: ?`);
                    this.socket.send(`Trunk Native Mode VLAN: ?`);
                    this.socket.send(`Administrative Native VLAN tagging: disabled`);
                    this.socket.send(`Allowed VLANs: 1-4095`);
                    this.socket.send(`Hybrid port configuration`);
                    this.socket.send(`-------------------------`);
                    this.socket.send(`Port Type: Unaware`);
                    this.socket.send(`Acceptable Frame Type: All`);
                    this.socket.send(`Ingress Filter: Disabled`);
                    this.socket.send(`Egress tagging: None`);
                    this.socket.send(`Hybrid Native Mode VLAN: ${nativeVlan}`);
                    this.socket.send(`Hybrid VLANs Enabled: ${vlansEnabled}`);
                    this.socket.sendRaw(`(config-if)# `);
                },
            },
            {
                regExp: /^show version\s*(\s*brief)?/i,
                callback: (match) => {
                    this.socket.send(match[0]);
                    if (match[1]) {
                        this.socket.send(`Version : v4.0.8.0`);
                        this.socket.send(`Build Date : 2017-10-12T12:59:58-06:00`);
                    }
                    else {
                        this.socket.send('MEMORY           : Total=75868 KBytes, Free=51069 KBytes, Max=51068 KBytes');
                        this.socket.send('FLASH            : 0x40000000-0x41ffffff, 512 x 0x10000 blocks');
                        this.socket.send('MAC Address      : a4-13-4e-1b-50-8b');
                        this.socket.send('Previous Restart : Cold');
                        this.socket.send('System Contact   : ');
                        this.socket.send('System Name      : ');
                        this.socket.send('System Location  : ');
                        this.socket.send('System Time      : 1970-01-02T22:35:16+00:00');
                        this.socket.send('System Uptime    : 1d 22:35:16');
                        this.socket.send('Active Image');
                        this.socket.send('------------');
                        this.socket.send('Image            : AMS-4424P-4.0.8.1.dat (primary)');
                        this.socket.send('Version          : v4.0.8.1');
                        this.socket.send('Date             : 2017-10-12T12:59:58-06:00');
                        this.socket.send('Alternate Image');
                        this.socket.send('---------------');
                        this.socket.send('Image            : AMS-4424P-4.1.2.dat (backup)');
                        this.socket.send('Version          : v4.1.2');
                        this.socket.send('Date             : 2018-10-31T12:01:57-06:00');
                        this.socket.send('Bootloader');
                        this.socket.send('----------');
                        this.socket.send('Image            : RedBoot (bootloader)');
                        this.socket.send('Version          : version 1_18-Vitesse');
                        this.socket.send('Date             : 14:18:19, Jan 22 2015');
                        this.socket.send('------------------');
                        this.socket.send('SID : 1 ');
                        this.socket.send('------------------');
                        this.socket.send('Chipset ID       : VSC7434 ');
                        this.socket.send('Board Type       : Jaguar-1 CU24 Reference');
                        this.socket.send('Port Count       : 26');
                        this.socket.send('Product          : Vitesse AMS-4424P Switch');
                        this.socket.send('Software Version : v4.0.8.1');
                        this.socket.send('Build Date       : 2017-10-12T12:59:58-06:00');
                    }
                    this.socket.sendRaw(`# `);
                },
            },
            {
                regExp: /^show( vlan)?/i,
                callback: (match) => {
                    this.socket.send(match[0]);
                    if (!match[1]) {
                        this.socket.send(`% Incomplete command.`);
                        return;
                    }
                    this.socket.send(`VLAN Name                             Interfaces`);
                    this.socket.send(`---- -------------------------------- ----------`);
                    this.vlans
                        .sort((a, b) => a.number - b.number)
                        .forEach(vlan => {
                        const vlanStr = vlan.number.toString().padEnd(4, ' ');
                        const name = vlan.name.padEnd(32, ' ');
                        const groups = this.groupInterfacesByUnit(vlan.interfaces);
                        groups.forEach((group, i) => {
                            const interfaces = this.createInterfacesString(group);
                            if (i === 0) {
                                this.socket.send(`${vlanStr} ${name} Gi ${interfaces}`);
                            }
                            else {
                                const padding = ''.padEnd(38, ' ');
                                this.socket.send(`${padding}Gi ${interfaces}`);
                            }
                        });
                    });
                    this.socket.sendRaw(`# `);
                },
            },
            {
                regExp: /^sw hy al vl 10,(\d+)$/i,
                callback: (match) => {
                    this.socket.send(match[0]);
                    // Switch current receive interface to the transmitter VLAN.
                    if (this.rxInterface === undefined) {
                        this.socket.send(`error - invalid receiver`);
                        this.socket.sendRaw(`(config-if)# `);
                        return;
                    }
                    const txVlanNumber = parseInt(match[1], 10);
                    const txVlan = this.vlans.find(vlan => vlan.number === txVlanNumber);
                    if (txVlan !== undefined) {
                        // Remove interface from any other transmitter VLANs.
                        for (const vlan of this.vlans) {
                            if (vlan.number <= 10)
                                continue;
                            const index = vlan.interfaces.findIndex(iface => {
                                var _a, _b;
                                return iface.unit === ((_a = this.rxInterface) === null || _a === void 0 ? void 0 : _a.unit) &&
                                    iface.port === ((_b = this.rxInterface) === null || _b === void 0 ? void 0 : _b.port);
                            });
                            if (index >= 0)
                                vlan.interfaces.splice(index, 1);
                        }
                        // Add interface to VLAN.
                        txVlan.interfaces.push(this.rxInterface);
                    }
                    else {
                        this.socket.send(`error - invalid vlan`);
                    }
                    this.socket.sendRaw(`(config-if)# `);
                },
            },
            {
                regExp: /^terminal length/i,
                callback: (match) => {
                    this.socket.send(match[0]);
                    this.socket.sendRaw(`# `);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`E10 : ERROR Command not found.`);
                    this.socket.sendRaw(`# `);
                },
            },
        ];
        this.authAsyncHandlers = [
            {
                regExp: /.+/i,
                callback: (match) => {
                    if (this.apiState === 'username') {
                        this.apiState = 'password';
                        this.socket.send(`#Password: `);
                    }
                    else {
                        this.apiState = 'authenticated';
                        this.asyncHandlers = this.apiAsyncHandlers;
                        this.socket.sendRaw(`# `);
                    }
                },
            },
        ];
        this.asyncHandlers = this.authAsyncHandlers;
        if (this.useBig) {
            this.initializeBig();
        }
        else {
            this.initializeSmall();
        }
    }
    onInitialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.apiState = 'username';
            this.asyncHandlers = this.authAsyncHandlers;
            yield this.timeouts.delay(1000);
            this.socket.sendRaw(`Username: `);
        });
    }
    // Convert array of interfaces to something like:
    //     1/2,1/5,1/9-16,5/7,5/9,6/8-12 (repeatUnit = true)
    //     1/2,5,9-16,5/7,9,6/8-12 (repeatUnit = false)
    createInterfacesString(interfaces, repeatUnit = false) {
        let str = '';
        let unit;
        const ports = [];
        interfaces.sort((a, b) => 1000 * a.unit + a.port - 1000 * b.unit - b.port);
        for (let i = 0; i <= interfaces.length; i++) {
            const iface = interfaces[i];
            if (unit !== (iface === null || iface === void 0 ? void 0 : iface.unit) || iface === undefined) {
                if (unit !== undefined) {
                    if (str.length !== 0)
                        str += ',';
                    if (repeatUnit) {
                        for (const portString of this.createPortString(ports).split(',')) {
                            str += `${unit}/${portString}`;
                        }
                    }
                    else {
                        str += `${unit}/${this.createPortString(ports)}`;
                    }
                }
                unit = iface === null || iface === void 0 ? void 0 : iface.unit;
                ports.length = 0;
            }
            if (iface)
                ports.push(iface.port);
        }
        return str;
    }
    // Convert [2,9,10,11,15,19] to '2,9-11,15,19'.
    createPortString(ports, sort = false) {
        let str = '';
        let start;
        if (sort)
            ports.sort((a, b) => a - b);
        ports.forEach((port, index) => {
            if (port === ports[index - 1] + 1) {
                if (index === ports.length - 1)
                    str += `-${port}`;
            }
            else {
                if (start !== undefined) {
                    str += start === ports[index - 1] ? ',' : `-${ports[index - 1]},`;
                }
                str += port;
                start = port;
            }
        });
        return str;
    }
    groupInterfacesByUnit(interfaces) {
        const groups = {};
        for (const iface of interfaces) {
            const unitStr = iface.unit.toString();
            if (!(unitStr in groups))
                groups[unitStr] = [];
            groups[unitStr].push(iface);
        }
        return Object.keys(groups)
            .sort()
            .map(unit => groups[unit]);
    }
    initializeBig() {
        this.vlans.push({
            name: `default`,
            number: 1,
            interfaces: this.parseInterfaces('1/1,49,50,2/1,49,50,3/1,49,50,4/1,49,50'),
        });
        this.vlans.push({
            name: `JAP_35x153`,
            number: 10,
            interfaces: this.parseInterfaces('1/2-48,2/2-48,3/2-48,4/2-48'),
        });
        this.vlans.push(this.makeTransmitterVlan(11, 1, 2, '1/2,37,43-48,2/16-48,3/27,29,36,43,4/15,19-48'));
        this.vlans.push(this.makeTransmitterVlan(12, 1, 3, '1/3,30,38,3/30,38,44'));
        this.vlans.push(this.makeTransmitterVlan(13, 1, 4, '1/4,31,39,3/31'));
        this.vlans.push(this.makeTransmitterVlan(14, 1, 5, '1/5,32,40,3/24,32,4/17'));
        this.vlans.push(this.makeTransmitterVlan(15, 1, 6, '1/6,33,41,3/34,41'));
        this.vlans.push(this.makeTransmitterVlan(16, 1, 7, '1/7,34-36,42,3/35,42'));
        this.vlans.push(this.makeTransmitterVlan(17, 1, 8, '1/8,2/2,3/25,37'));
        this.vlans.push(this.makeTransmitterVlan(18, 1, 9, '1/9'));
        this.vlans.push(this.makeTransmitterVlan(19, 1, 10, '1/10'));
        this.vlans.push(this.makeTransmitterVlan(20, 1, 11, '1/11'));
        this.vlans.push(this.makeTransmitterVlan(21, 1, 12, '1/12,2/4-7'));
        this.vlans.push(this.makeTransmitterVlan(22, 3, 2, '3/2'));
        this.vlans.push(this.makeTransmitterVlan(23, 3, 3, '3/3'));
        this.vlans.push(this.makeTransmitterVlan(24, 3, 4, '3/4'));
        this.vlans.push(this.makeTransmitterVlan(25, 3, 5, '3/5'));
        this.vlans.push(this.makeTransmitterVlan(26, 3, 6, '3/6'));
        this.vlans.push(this.makeTransmitterVlan(27, 3, 7, '3/7,28'));
        this.vlans.push(this.makeTransmitterVlan(28, 3, 8, '2/3,3/8'));
        this.vlans.push(this.makeTransmitterVlan(29, 3, 9, '3/9'));
        this.vlans.push(this.makeTransmitterVlan(30, 3, 10, '3/10'));
        this.vlans.push(this.makeTransmitterVlan(31, 3, 11, '3/11'));
        this.vlans.push(this.makeTransmitterVlan(32, 3, 12, '1/13-29,3/12,45-48,4/9-14,16'));
        this.vlans.push(this.makeTransmitterVlan(33, 3, 13, '3/13,19-22'));
        this.vlans.push(this.makeTransmitterVlan(34, 3, 14, '3/14,33,39'));
        this.vlans.push(this.makeTransmitterVlan(35, 3, 15, '3/15/40'));
        this.vlans.push(this.makeTransmitterVlan(36, 3, 16, '3/16'));
        this.vlans.push(this.makeTransmitterVlan(37, 3, 17, '2/8-15,3/17'));
        this.vlans.push(this.makeTransmitterVlan(38, 3, 18, '3/18,23,26'));
        this.vlans.push(this.makeTransmitterVlan(39, 4, 2, '4/2,18'));
        this.vlans.push(this.makeTransmitterVlan(40, 4, 3, '4/3'));
        this.vlans.push(this.makeTransmitterVlan(41, 4, 4, '4/4'));
        this.vlans.push(this.makeTransmitterVlan(42, 4, 5, '4/5'));
        this.vlans.push(this.makeTransmitterVlan(43, 4, 6, '4/6'));
        this.vlans.push(this.makeTransmitterVlan(44, 4, 7, '4/7'));
        this.vlans.push(this.makeTransmitterVlan(45, 4, 8, '4/8'));
    }
    initializeSmall() {
        const numTransmitters = 7;
        const numReceivers = 8;
        // VLAN 1: default
        this.vlans.push({
            name: 'default',
            number: 1,
            interfaces: [1, 17, 18, 19, 20, 21, 22, 23, 24].map(port => ({ unit: 1, port })),
        });
        // VLAN 10: Just Add Power Devices
        const vlan10 = {
            name: `JAP_${numTransmitters}x${numReceivers}`,
            number: 10,
            interfaces: [],
        };
        this.vlans.push(vlan10);
        let port = 2;
        for (let i = 0; i < numTransmitters; i++) {
            vlan10.interfaces.push({ unit: 1, port });
            this.transmitters.push({ unit: 1, port });
            port++;
            // VLANs 11+: transmitter VLANs
            const vlan = {
                name: `TX_${i + 1}_gi1/${i + 2}`,
                number: i + 11,
                interfaces: [{ unit: 1, port: i + 2 }],
            };
            // Initially route the first transmitter to all receivers.
            if (i === 0) {
                for (let j = 0; j < numReceivers; j++) {
                    vlan.interfaces.push({
                        unit: 1,
                        port: 2 + numTransmitters + j,
                    });
                }
            }
            this.vlans.push(vlan);
        }
        for (let i = 0; i < numReceivers; i++) {
            vlan10.interfaces.push({ unit: 1, port });
            port++;
        }
    }
    makeTransmitterVlan(vlanNumber, txUnit, txPort, interfaces) {
        return {
            name: this.makeVlanName(vlanNumber, txUnit, txPort),
            number: vlanNumber,
            interfaces: this.parseInterfaces(interfaces),
        };
    }
    makeVlanName(vlanNumber, txUnit, txPort) {
        return `TX_${vlanNumber - 10}_gi${txUnit}/${txPort}`;
    }
    parseRange(str) {
        const values = [];
        const parts = str.split(',');
        for (const part of parts) {
            const range = part.split('-');
            if (range.length === 1) {
                values.push(parseInt(range[0]));
            }
            else {
                const start = parseInt(range[0]);
                const end = parseInt(range[1]);
                for (let value = start; value <= end; value++) {
                    values.push(value);
                }
            }
        }
        return values;
    }
    parseInterfaces(str) {
        const interfaces = [];
        const parts = str.split(',');
        let unit = 1;
        for (const part of parts) {
            const components = part.split('/');
            const n = components.length;
            const ports = this.parseRange(components[n - 1]);
            if (n > 1)
                unit = parseInt(components[0], 10);
            for (const port of ports) {
                const iface = {
                    unit,
                    port,
                };
                interfaces.push(iface);
            }
        }
        return interfaces;
    }
}
JustAddPower.emulatorType = 'socketEmulator';
JustAddPower.key = '-MW1DnbejiTxMr6KVBuy';
